var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticClass: "change-password-btn",
          attrs: { type: "text" },
          on: { click: _vm.toggleDisplayCheckPassword }
        },
        [_vm._v("\n    Change Password\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-change-pw",
          attrs: {
            "before-close": _vm.handleCloseCheckPassword,
            visible: _vm.passwordCheckDialogVisible,
            "close-on-click-modal": false,
            center: true,
            width: "90%"
          },
          on: {
            "update:visible": function($event) {
              _vm.passwordCheckDialogVisible = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("Change Password")]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              staticClass: "dialog-form",
              attrs: {
                model: _vm.matchPasswordDialogForm,
                rules: _vm.formRules,
                "label-width": "auto"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "password" } },
                [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Current Password")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-input",
                    {
                      staticClass: "input-group-pw",
                      attrs: {
                        placeholder: "Password",
                        type: _vm.viewCurrentPassword ? "text" : "password"
                      },
                      model: {
                        value: _vm.matchPasswordDialogForm.password,
                        callback: function($$v) {
                          _vm.$set(_vm.matchPasswordDialogForm, "password", $$v)
                        },
                        expression: "matchPasswordDialogForm.password"
                      }
                    },
                    [
                      _c("template", { slot: "prepend" }, [
                        _c("i", { staticClass: "el-icon-lock" })
                      ]),
                      _vm._v(" "),
                      !_vm.viewCurrentPassword
                        ? _c("template", { slot: "append" }, [
                            _c("i", {
                              staticClass: "el-icon-view",
                              on: {
                                click: function($event) {
                                  _vm.viewCurrentPassword = !_vm.viewCurrentPassword
                                }
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.viewCurrentPassword
                        ? _c("template", { slot: "append" }, [
                            _c("img", {
                              staticClass: "icon-hide",
                              attrs: {
                                src: require("../../../assets/el-icon-hide.svg")
                              },
                              on: {
                                click: function($event) {
                                  _vm.viewCurrentPassword = !_vm.viewCurrentPassword
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-change-pw",
                  on: { click: _vm.checkCurrentPassword }
                },
                [_vm._v("\n        Next\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-change-pw",
          attrs: {
            "before-close": _vm.handleCloseResetPassword,
            visible: _vm.passwordResetDialogVisible,
            "close-on-click-modal": false,
            center: true,
            width: "90%"
          },
          on: {
            "update:visible": function($event) {
              _vm.passwordResetDialogVisible = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("Change Password")]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              staticClass: "dialog-form",
              attrs: {
                model: _vm.changePasswordDialogForm,
                rules: _vm.formRules,
                "label-width": "auto"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "newPassword" } },
                [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("New Password")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-input",
                    {
                      staticClass: "input-group-pw",
                      attrs: {
                        placeholder: "New Password",
                        type: _vm.viewNewPassword ? "text" : "password"
                      },
                      on: { input: _vm.validatePasswords },
                      model: {
                        value: _vm.changePasswordDialogForm.newPassword,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.changePasswordDialogForm,
                            "newPassword",
                            $$v
                          )
                        },
                        expression: "changePasswordDialogForm.newPassword"
                      }
                    },
                    [
                      _c("template", { slot: "prepend" }, [
                        _c("i", { staticClass: "el-icon-lock" })
                      ]),
                      _vm._v(" "),
                      !_vm.viewNewPassword
                        ? _c("template", { slot: "append" }, [
                            _c("i", {
                              staticClass: "el-icon-view",
                              on: {
                                click: function($event) {
                                  _vm.viewNewPassword = !_vm.viewNewPassword
                                }
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.viewNewPassword
                        ? _c("template", { slot: "append" }, [
                            _c("img", {
                              staticClass: "icon-hide",
                              attrs: {
                                src: require("../../../assets/el-icon-hide.svg")
                              },
                              on: {
                                click: function($event) {
                                  _vm.viewNewPassword = !_vm.viewNewPassword
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "confirmPassword" } },
                [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Confirm Password")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-input",
                    {
                      staticClass: "input-group-pw",
                      attrs: {
                        placeholder: "Confirm Password",
                        type: _vm.viewConfirmPassword ? "text" : "password"
                      },
                      on: { input: _vm.validatePasswords },
                      model: {
                        value: _vm.changePasswordDialogForm.confirmPassword,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.changePasswordDialogForm,
                            "confirmPassword",
                            $$v
                          )
                        },
                        expression: "changePasswordDialogForm.confirmPassword"
                      }
                    },
                    [
                      _c("template", { slot: "prepend" }, [
                        _c("i", { staticClass: "el-icon-lock" })
                      ]),
                      _vm._v(" "),
                      !_vm.viewConfirmPassword
                        ? _c("template", { slot: "append" }, [
                            _c("i", {
                              staticClass: "el-icon-view",
                              on: {
                                click: function($event) {
                                  _vm.viewConfirmPassword = !_vm.viewConfirmPassword
                                }
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.viewConfirmPassword
                        ? _c("template", { slot: "append" }, [
                            _c("img", {
                              staticClass: "icon-hide",
                              attrs: {
                                src: require("../../../assets/el-icon-hide.svg")
                              },
                              on: {
                                click: function($event) {
                                  _vm.viewConfirmPassword = !_vm.viewConfirmPassword
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-change-pw",
                  attrs: { disabled: !_vm.isPasswordMatch },
                  on: { click: _vm.updatePassword }
                },
                [_vm._v("\n        Save\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fbc7ebe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fbc7ebe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/components/changePassword.vue
// module id = null
// module chunks = 